module.exports = __webpack_public_path__ + "assets/images/dropdown-chevron-icon.57f8c88e1a7650096b1c3d0bfa3bca90.svg";